module.exports = __webpack_public_path__ + "static/bgl-ffc3f988f25b0c331a6ebf2e4b0510d3.jpg";